<div class="notificationHolder">
  @for (notification of notificationExtract$ | async; track notification) {
    @if (notification.show) {
      <div class="govuk-error-summary" role="alert">
        <h2 class="hods-alert__heading">There is a problem</h2>
        <p>{{ notification.message }}</p>
      </div>
    }
  }
</div>
